import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Airpods = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "airpods",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2 7.625c0 2.2782 1.8468 4.125 4.125 4.125.3059 0 .4588 0 .538.0273.1659.0572.2524.1438.3097.3096.0273.0793.0273.2034.0273.4517v6.3364c0 .8975.7275 1.625 1.625 1.625s1.625-.7275 1.625-1.625V7.625c0-2.2782-1.8468-4.125-4.125-4.125S2 5.3468 2 7.625Zm20 0c0 2.2782-1.8468 4.125-4.125 4.125-.3059 0-.4588 0-.5381.0273-.1658.0572-.2524.1438-.3096.3096-.0273.0793-.0273.2034-.0273.4517v6.3364c0 .8975-.7275 1.625-1.625 1.625s-1.625-.7275-1.625-1.625V7.625c0-2.2782 1.8468-4.125 4.125-4.125S22 5.3468 22 7.625Z"
    })
  }));
};
export default Airpods;